export default __webpack_public_path__ + "static/media/conteudo_extra_07_19.41d5f3ba.jpg";